import { useLPSuspenseQuery } from '../lib/hooks/useLPQuery';

export function useManagerTeamCampaignsQuery() {
  return useLPSuspenseQuery<ManagerTeamCampaign[]>(['campaigns'], `/manager/campaigns`);
}

export type ManagerTeamCampaign = {
  campaignId: string;
  campaignName: string;
  campaignStatus: 'notStarted' | 'inProgress' | 'completed';
  campaignKind: string;
  startDate: string;
  durationDays: number;
  doInitialAssessment: boolean;
  description: string;
  organisationId: string;
  creationDate: string;
  mandatoryModules: string[];
  dynamicModules: string[];
  linkedCampaignId: string;
  enrolled: number;
  completed: number;
  started: number;
  failed: number;
  dueDate?: string;
  campaignUrl?: string;
};
